export const CLOSE_MENU_DELAY = 1500
